import { render, staticRenderFns } from "./PropertyListItem.vue?vue&type=template&id=c8bdd45c&scoped=true&"
import script from "./PropertyListItem.vue?vue&type=script&lang=ts&"
export * from "./PropertyListItem.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyListItem.vue?vue&type=style&index=0&id=c8bdd45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bdd45c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
